// Revival: review summary and highlights from Yotpo's public widget API (no auth; CORS enabled).
// Fills [data-rv-rating] (stars + count, only if Shopify's reviews metafields didn't already) and
// [data-rv-review-highlights] (N most recent 5-star reviews with meaningful text). Replace with
// Klaviyo Reviews later; the markup does not depend on Yotpo.
(function () {
  var script = document.currentScript;
  var key = script && script.dataset.yotpoKey;
  var pid = script && script.dataset.productId;
  if (!key || !pid || window.__rvReviewsLoaded) return;
  window.__rvReviewsLoaded = true;

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function decode(s) { var t = document.createElement('textarea'); t.innerHTML = s || ''; return t.value; }

  fetch('https://api-cdn.yotpo.com/v1/widget/' + key + '/products/' + pid + '/reviews.json?per_page=30&page=1&sort=date&direction=desc')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var res = (data && data.response) || {};
      var bl = res.bottomline || {};
      var total = bl.total_review || 0;
      var avg = bl.average_score || 0;

      var rating = document.querySelector('[data-rv-rating]');
      if (rating && rating.hidden && total > 0) {
        rating.querySelector('.rv-stars').style.setProperty('--rv-rating', avg);
        rating.querySelector('[data-rv-rating-text]').textContent = avg.toFixed(1) + ' (' + total.toLocaleString() + ' reviews)';
        rating.hidden = false;
      }

      var box = document.querySelector('[data-rv-review-highlights]');
      if (!box) return;
      var want = Number(box.dataset.count || 2);
      var picks = (res.reviews || []).filter(function (r) {
        return r.score === 5 && decode(r.content).trim().length >= 25;
      }).slice(0, want);
      if (!picks.length) return;
      box.querySelector('[data-rv-rh-list]').innerHTML = picks.map(function (r) {
        var date = r.created_at ? new Date(r.created_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }) : '';
        var title = decode(r.title);
        var body = decode(r.content);
        if (body.length > 220) body = body.slice(0, 217).replace(/\s+\S*$/, '') + '…';
        var showTitle = title && body.toLowerCase().indexOf(title.toLowerCase()) !== 0;
        return '<li class="rv-rh__item">' +
          '<div class="rv-rh__head"><span class="rv-stars" style="--rv-rating:5" aria-label="5 out of 5 stars"></span>' +
          '<span>' + esc((r.user && r.user.display_name) || 'Customer') + '</span>' +
          (r.verified_buyer ? '<span class="rv-rh__verified">Verified buyer</span>' : '') +
          (date ? '<span>' + esc(date) + '</span>' : '') + '</div>' +
          '<p class="rv-rh__text">' + (showTitle ? '<strong>' + esc(title) + '</strong>' : '') + esc(body) + '</p></li>';
      }).join('');
      box.hidden = false;
    })
    .catch(function () { /* reviews are optional */ });
})();
